import { getPath } from '@/router/common'

const baseUrl = {
  title: '上游来货',
  path: 'UpsteamOrder'
}

export default[
    {
        path: getPath('index', baseUrl),
        name: 'UpsteamOrder_index',
        component: () => import(/* webpackChunkName: "UpsteamOrder_index" */ '@/views/upsteamOrder/index/index.vue'),
        meta: {
          title: '上游来货'
        }
      }
]
